var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.1279H28C29.1046 10.1279 30 11.0234 30 12.1279V28.1279C30 29.2325 29.1046 30.1279 28 30.1279H12C10.8954 30.1279 10 29.2325 10 28.1279V12.1279C10 11.0234 10.8954 10.1279 12 10.1279ZM12 12.1279V28.1279H28V12.1279H12ZM19.1331 20.1323H21V26.1279H23V20.1323H24.9824V18.1323H23V17.1279C23 16.5756 23.4477 16.1279 24 16.1279H25V14.1279H24C22.3431 14.1279 21 15.4711 21 17.1279V18.1323H19.1331V20.1323Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.62793,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#3A3A3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircled);
export default __webpack_public_path__ + "static/media/facebook-circled.34436a20b35c925759d09e90860ccba2.svg";
export { ForwardRef as ReactComponent };